export const currentAcademicYear = (d = new Date()) => {
  const y = d.getMonth() >= 8 ? d.getFullYear() : d.getFullYear() - 1;
  return `${y}-${y + 1}`;
};

export const academicYearOptions = (before = 2, after = 1) => {
  const start = parseInt(currentAcademicYear().split('-')[0], 10);
  return Array.from({ length: before + after + 1 }, (_, i) => start - before + i).map((y) => `${y}-${y + 1}`);
};
